import { PageParams, RouteBuilders, RouteUpdaters } from "./routes.shared";
import { Pages } from "../../../EntryPoint/Frontend/routes/routes.state";
import { Updater } from "widgets-for-react";


export type HomePages = {
  home: { url: []; };
};

export const homeRouteBuilder = <state>(): RouteBuilders<state, HomePages> => ({
  home: {
    make: (params: PageParams<Pages["home"]>) => ({ kind: "home", params: params })
  }
});

export const homeRouteUpdater = <state>(): RouteUpdaters<state, HomePages> => ({
  home: {
    jumpTo: (params: PageParams<HomePages["home"]>): Updater<state> => s0 => ({ ...s0, page: homeRouteBuilder<state>().home.make(params) }),
    url: "/spa/home"
  },
});
